import React, { Component } from 'react';
// import { StyleSheet, css } from 'aphrodite';
// import { Grid,Row,Col,Nav } from 'react-bootstrap';

import { connect } from 'react-redux'

import Nav2 from '../assets/navBar'
import Controlls from '../assets/controlls'
import Content from '../assets/content'
import NewPromo from '../assets/modalNovaPromo'
import {getUserData} from '../redux/actions/user'
class Home extends Component {
    componentDidMount(){
        this.props.getUserData()
    }
    render(){
        return ( 
            <div className="container display-table"> 
                <div className="navbar navbar-default">
                        <Nav2/>
                        </div>
                    <div className="col-md-12 col-sm-12 display-table-cell v-align">
                        <Controlls/>
                        <Content/>
                       <NewPromo/>
                    </div>
                
            </div>
        );
    }
}
// const styles = StyleSheet.create({
//     form: {
//         height: '97vh',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: '0px',
//         margin: '0px',
//         paddingRight:'0px',
//         paddingLeft:'0px',
//     },
//     divmenu: {
//         paddingLeft:'0px',
//         paddingRight:'0px',
//         paddingBottom:'0px',
//         '@media (max-width: 991px)': {
//             height: '100px',
//         }
//     },
// })

export default connect(null, {getUserData})(Home)


// WEBPACK FOOTER //
// ./src/cenas/Feed.js